const LICENSE_GROUP_INTEGRATIONS_LIST_EVENT = {
  UPDATE: {
    COUNT: 'UpdateLicenseGroupIntegrationsCount',
    LIST: 'UpdateLicenseGroupIntegrationsList',
  },
};

export {LICENSE_GROUP_INTEGRATIONS_LIST_EVENT};
